import React from "react";
import { Router, Switch } from "react-router-dom";

import {
  ADMINISTRATOR,
  CREDIT,
  ORDEM_COMPRA,
  PERMISSIONS,
} from "../app/permissions";
import RegistrationUser from "../pages/RegistrationUser";
import Home from "../pages/Home/";
import history from "../utils/history";
import Login from "../pages/Login";
import UserRegistration from "../pages/UserRegistration";
import AgentsRegistration from "../pages/AgentsRegistration";
import RegistrationPJ from "../pages/RegistrationPJ";
import CustomRoute from "./CustomRoute";
import UserList from "../pages/UserList";
import Manutencao from "../pages/Manutencao";
import StoreRegistration from "../pages/StoreRegistration";
import RegionalRegistration from "../pages/RegionalRegistration";
import ConvenioRegistration from "../pages/ConvenioRegistration";
import StoreList from "../pages/StoreList";
import AgentList from "../pages/AgentList";
import PJList from "../pages/PJList";
import PFList from "../pages/PFList";
import Whitelist from "../pages/Whitelist";
import RegionalList from "../pages/RegionalList";
import ConveniosList from "../pages/ConveniosList";
import PasswordReset from "../pages/PasswordReset";
import ForgotPassWord from "../pages/ForgotPassword";
import RoleRegistration from "../pages/RoleRegistration";
import EditParameters from "../pages/EditParameters";
import CreditList from "../pages/CreditList";
import OrdemCompraList from "../pages/OrdemCompraList";
import HistoryAgentStore from "../pages/HistoryAgentStore";
import PermissionsRegistration from "../pages/PermissionsRegistration";
import ViewCreditProposal from "../pages/ViewCreditProposal";
import MotivoRejeicaoRegistration from "../pages/MotivoRejeicaoRegistration";
import MotivosRejeicaoList from "../pages/MotivosRejeicaoList";

export default function Routes() {
  return (
    <Router history={history}>
      <Switch>
        <CustomRoute path="/home" isPrivate exact component={Home} />
        <CustomRoute path="/" exact component={Login} />
        <CustomRoute path="/forgot-password" exact component={ForgotPassWord} />
        <CustomRoute
          path="/recovery-password"
          exact
          component={PasswordReset}
        />

        <CustomRoute
          path="/cadastro-usuario/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={UserRegistration}
        />
        <CustomRoute
          path="/cadastro-pessoa-fisica/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={RegistrationUser}
        />
        <CustomRoute
          path="/cadastro-pessoa-juridica/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={RegistrationPJ}
        />
        <CustomRoute
          path="/cadastro-lojas/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={StoreRegistration}
        />
        <CustomRoute
          path="/cadastro-agentes/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={AgentsRegistration}
        />
        <CustomRoute
          path="/cadastro-regionais/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={RegionalRegistration}
        />
        <CustomRoute
          path="/cadastro-convenios/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={ConvenioRegistration}
        />
        <CustomRoute
          path="/cadastro-motivos-rejeicao/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={MotivoRejeicaoRegistration}
        />

        <CustomRoute
          path="/usuario"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={UserList}
        />
        <CustomRoute
          path="/lojas"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={StoreList}
        />
        <CustomRoute
          path="/agentes"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={AgentList}
        />
        <CustomRoute
          path="/pessoa-juridica"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={PJList}
        />
        <CustomRoute
          path="/pessoa-fisica"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={PFList}
        />
        <CustomRoute
          path="/regionais"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={RegionalList}
        />
        <CustomRoute
          path="/convenios"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={ConveniosList}
        />
        <CustomRoute
          path="/motivos-rejeicao"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={MotivosRejeicaoList}
        />
        <CustomRoute
          path="/historico/agente/:id?"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={HistoryAgentStore}
        />
        <CustomRoute
          path="/front-de-credito"
          isPrivate
          permissions={[CREDIT]}
          component={CreditList}
        />
        <CustomRoute
          path="/ordem-compra"
          isPrivate
          permissions={[ORDEM_COMPRA]}
          component={OrdemCompraList}
        />
        <CustomRoute
          path="/visualizar-proposta/:proposalNumber/:cpfCnpj"
          isPrivate
          permissions={[CREDIT]}
          component={ViewCreditProposal}
        />

        <CustomRoute
          path="/whitelist"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={Whitelist}
        />
        <CustomRoute
          path="/parametros"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={EditParameters}
        />
        <CustomRoute
          path="/role-registration"
          isPrivate
          permissions={[ADMINISTRATOR]}
          component={RoleRegistration}
        />
        <CustomRoute
          path="/permissions-registration"
          isPrivate
          permissions={[PERMISSIONS]}
          component={PermissionsRegistration}
        />

        <CustomRoute
          path="/manutencao/:name"
          isPrivate
          permissions={[]}
          component={Manutencao}
        />
      </Switch>
    </Router>
  );
}
